import React, { useEffect, useMemo, useState } from 'react'
import { I18n } from "aws-amplify";

import { isStringType } from './../../shared/utils/misc'
import { USER, DATE_CONJUNCTION, ACTIVE } from './../../shared/constants/index'

import { Row, Col, Accordion, Form, Button } from 'react-bootstrap'

export const UserFilter = (props) => {
  // props を分解（lint対策：依存に props 全体を入れない）
  const {
     filter: setFilter, 
     nextToken: setNextToken, 
     nextRead: setNextRead, 
     load 
  } = props;
  
  const defaultFilter = {
    'active': true
  }

  const [username, setUsername] = useState("")
  const [companyName, setCompanyName] = useState("")
  const [address, setAddress] = useState("")
  const [telephoneNumber, setTelephoneNumber] = useState("")
  const [mailaddress, setMailaddress] = useState("")

  const [updateStartDate, setUpdateStartDate] = useState("")
  const [updateEndDate, setUpdateEndDate] = useState("")
  const [createStartDate, setCreateStartDate] = useState("")
  const [createEndDate, setCreateEndDate] = useState("")

  const [active, setActive] = useState(ACTIVE.ON);
  const activeList = [
    { name: 'general_unselected', value: ACTIVE.NONE },
    { name: 'general_active', value: ACTIVE.ON },
    { name: 'general_inactive', value: ACTIVE.OFF },
  ];

  // 入力変更時に追加読み込みを封じる（nextToken/nextRead をリセット）
  const invalidate = () => {
    setNextToken(null);
    setNextRead(false);
  };

  // 入力バインドの共通ヘルパ
  const bind = (setter) => (e) => {
    setter(e.target.value);
    invalidate();
  };

  // 送信用の条件をメモ化（ボタン押下時に利用）
  const criteria = useMemo(() => {
    const c = {};
    if (isStringType(username)) c[USER.TABLE_COLUMN.USERNAME] = username;
    if (isStringType(companyName)) c[USER.TABLE_COLUMN.COMPANY_NAME] = companyName;
    if (isStringType(address)) c[USER.TABLE_COLUMN.ADDRESS] = address;
    if (isStringType(telephoneNumber)) c[USER.TABLE_COLUMN.TELEPHONE_NUMBER] = telephoneNumber;
    if (isStringType(mailaddress)) c[USER.TABLE_COLUMN.MAILADDRESS] = mailaddress;

    if (isStringType(updateStartDate) && updateStartDate !== '') {
      c[USER.TABLE_COLUMN.UPDATED_AT + 'Gt'] = updateStartDate + DATE_CONJUNCTION.START_SUFFIX;
    }
    if (isStringType(updateEndDate) && updateEndDate !== '') {
      c[USER.TABLE_COLUMN.UPDATED_AT + 'Lt'] = updateEndDate + DATE_CONJUNCTION.END_SUFFIX;
    }
    if (isStringType(createStartDate) && createStartDate !== '') {
      c[USER.TABLE_COLUMN.CREATED_AT + 'Gt'] = createStartDate + DATE_CONJUNCTION.START_SUFFIX;
    }
    if (isStringType(createEndDate) && createEndDate !== '') {
      c[USER.TABLE_COLUMN.CREATED_AT + 'Lt'] = createEndDate + DATE_CONJUNCTION.END_SUFFIX;
    }

    switch (active) {
      case ACTIVE.ON:
        c[USER.TABLE_COLUMN.ACTIVE] = true;
        break;
      case ACTIVE.OFF:
        c[USER.TABLE_COLUMN.ACTIVE] = false;
        break;
      case ACTIVE.NONE:
      default:
        break;
    }
    return c;
  }, [
    username,
    companyName,
    address,
    telephoneNumber,
    mailaddress,
    updateStartDate,
    updateEndDate,
    createStartDate,
    createEndDate,
    active,
  ]);

  // 検索初期化
  const clear = () => {
    setUsername('');
    setCompanyName('');
    setAddress('');
    setTelephoneNumber('');
    setMailaddress('');
    setActive(ACTIVE.ON);
    setUpdateStartDate('');
    setUpdateEndDate('');
    setCreateStartDate('');
    setCreateEndDate('');

    invalidate();          // クリアでもページングを無効化
    setFilter(defaultFilter);
  };

  // 検索実行
  const executeFilter = () => {
    const isEmpty = Object.keys(criteria).length === 0;
    setFilter(isEmpty ? null : criteria);
  };

  return (
    <>
      <Row>
        <Col xs={12} md={12} className="mt-1">
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header bsPrefix="accordion-button-custom">
                {I18n.get('general_filter')}{' '}
              </Accordion.Header>

              <Accordion.Body>
                <Row className="mt-1">
                  <Col xs={12} md={6}>
                    <Form.Group as={Row} className="mb-3" controlId="form-filter-username">
                      <Form.Label column sm={4}>
                        {I18n.get('table_column_user_username')}
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          type="text"
                          disabled={load}
                          placeholder={I18n.get('general_unselected')}
                          value={username}
                          onChange={bind(setUsername)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Group as={Row} className="mb-3" controlId="form-filter-companyName">
                      <Form.Label column sm={4}>
                        {I18n.get('table_column_user_company_name')}
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          type="text"
                          disabled={load}
                          placeholder={I18n.get('general_unselected')}
                          value={companyName}
                          onChange={bind(setCompanyName)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mt-1">
                  <Col xs={12} md={6}>
                    <Form.Group as={Row} className="mb-3" controlId="form-filter-mailaddress">
                      <Form.Label column sm={4}>
                        {I18n.get('table_column_user_mailaddress')}
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          type="text"
                          disabled={load}
                          placeholder={I18n.get('general_unselected')}
                          value={mailaddress}
                          onChange={bind(setMailaddress)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6} />
                </Row>

                <Row className="mt-1">
                  <Col xs={12} md={12}>
                    <Form.Group as={Row} className="mb-3" controlId="form-filter-update-date">
                      <Form.Label column sm={2}>
                        {I18n.get('general_latest_update')}
                      </Form.Label>
                      <Col sm={4}>
                        <Form.Control
                          type="date"
                          disabled={load}
                          value={updateStartDate}
                          onChange={bind(setUpdateStartDate)}
                        />
                      </Col>
                      <Form.Label column sm={1} className="text-center">
                        {I18n.get('general_date_between')}
                      </Form.Label>
                      <Col sm={4}>
                        <Form.Control
                          type="date"
                          disabled={load}
                          value={updateEndDate}
                          onChange={bind(setUpdateEndDate)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mt-1">
                  <Col xs={12} md={12}>
                    <Form.Group as={Row} className="mb-3" controlId="form-filter-create-date">
                      <Form.Label column sm={2}>
                        {I18n.get('general_create_date')}
                      </Form.Label>
                      <Col sm={4}>
                        <Form.Control
                          type="date"
                          disabled={load}
                          value={createStartDate}
                          onChange={bind(setCreateStartDate)}
                        />
                      </Col>
                      <Form.Label column sm={1} className="text-center">
                        {I18n.get('general_date_between')}
                      </Form.Label>
                      <Col sm={4}>
                        <Form.Control
                          type="date"
                          disabled={load}
                          value={createEndDate}
                          onChange={bind(setCreateEndDate)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mt-1">
                  <Col xs={12} md={6}>
                    <Form.Group as={Row} className="mb-3" controlId="form-filter-state">
                      <Form.Label column sm={4}>{I18n.get('general_status')}</Form.Label>
                      <Col sm={8}>
                        {activeList.map((radio, idx) => (
                          <Form.Check
                            key={`usf-${idx}`}
                            className="toggleButtonInline"
                            inline
                            disabled={load}
                            id={`radio-state-${idx}`}
                            type="radio"
                            name="group1"
                            value={radio.value}
                            checked={active === radio.value}
                            label={I18n.get(radio.name)}
                            onChange={(e) => { setActive(e.currentTarget.value); invalidate(); }}
                          />
                        ))}
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6} />
                </Row>

                <Row>
                  <Col xs={12} md={12} className="mt-1">
                    <div className="text-end">
                      <Button
                        variant="secondary"
                        disabled={load}
                        style={{ marginRight: '5px' }}
                        onClick={clear}
                      >
                        {I18n.get('general_clear')}
                      </Button>{' '}
                      <Button variant="primary" disabled={load} onClick={executeFilter}>
                        {I18n.get('general_apply')}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
    </>
  );
}